<template>
  <div id="pageRoot">
    <p id="text01" class="textBase pageElement">
      Los dos hermanos mayores fueron a buscar ramitas para encender un fuego
      bajo el árbol. Con el humo iban a asfixiar a las abejas y así podrían
      quitarles la miel.<br /><br />
      Serafín se paró adelante del panal y dijo:<br /><br />
      —¡Dejen en paz a las abejas! ¡No permitiré que las quemen!<br /><br />
      Los mayores discutieron porque en realidad tenían mucha, mucha hambre. Se
      acercaba la noche y no habían comido ni un pedacito de pan. Finalmente,
      Serafín logró convencerlos y los tres siguieron andando. Tenían que
      encontrar un lugar donde dormir lo antes posible.<br /><br />
      Justo cuando caía el sol, llegaron a un palacio. Recorrieron los jardines
      y no vieron a nadie. Entraron a las caballerizas y descubrieron que
      estaban repletas de caballos. Pero todos se habían vuelto de piedra. Algo
      asustados, los tres hermanos entraron en el palacio. Cruzaron una sala, y
      otra, y otra más. Estaba vacío. Al final de un largo corredor, en una
      pequeña habitación, encontraron un hombrecito.
    </p>
  </div>
</template>
<style scoped>
#text01 {
  position: absolute;
  left: 41px;
  top: 32px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["cas/Video 7.mp4", "cas/Video 8b.mp4"],
    };
  },
};
</script>
